/**
 * Riempie i valori di telefono e cellulare durante l'update di una riga in un indirizzo.
 * @param {any} data
 */
function gridIndirizziSpedizione_rowUpdating(data) {
    data.newData.Cellulare = $('#gridIndirizziSpedizione [name="Cellulare"]').val();
    data.newData.Telefono = $('#gridIndirizziSpedizione [name="Telefono"]').val();
}

/**
 * Riempie i valori di telefono e cellualare durante l'inserimento di un nuovo indirizzo.
 * @param {any} data
 */
function gridIndirizziSpedizione_rowInserting(data) {
    data.data.Cellulare = $('#gridIndirizziSpedizione [name="Cellulare"]').val();
    data.data.Telefono = $('#gridIndirizziSpedizione [name="Telefono"]').val();
}

/**
 * Funzione che all'apertura dell'editor per l'update riempie i valori di telefono e cellulare.
 * @param {any} data
 */
function gridIndirizziSpedizione_editorPrepared(data) {
    try {
        setTimeout(function () {

            var key = $('#gridIndirizziSpedizione').dxDataGrid('instance').option('editing.editRowKey');
            var index = $('#gridIndirizziSpedizione').dxDataGrid('instance').getRowIndexByKey(key);
            var rowData = $('#gridIndirizziSpedizione').dxDataGrid('instance').getVisibleRows()[index]

            if (rowData) {
                $('#gridIndirizziSpedizione [name="Cellulare"]').val(rowData.data.Cellulare);
                $('#gridIndirizziSpedizione [name="Telefono"]').val(rowData.data.Telefono);
            }

        }, 100);
    } catch (err) {
        console.log(err);
    }
}

/**
 * Sposta il campo di ricerca da destra a sinistra
 * @param {any} e
 */
const SearchPanelLeft = function (e) {
    let toolbarItems = e.toolbarOptions.items;
    toolbarItems.forEach(function (item) {
        if (item.name === "searchPanel") {
            item.location = 'before';
        }
        if (item.name === "groupPanel") {
            item.location = 'after';
        }
    })
}
/**
 * ottiene il valore di una cella in editing
 * se serve da un'altra parte, renderlo generico nel JS
 */
function GetValueProvincia() {
    var key = $('#gridIndirizziSpedizione').dxDataGrid('instance').option('editing.editRowKey');

    var index = $('#gridIndirizziSpedizione').dxDataGrid('instance').getRowIndexByKey(key);

    return $('#gridIndirizziSpedizione').dxDataGrid('instance').cellValue(index, 'Provincia');
}

/**
 * Imposta il valore della provincia della griglia degli indirizzi di spedizione.
 * Controlla anche che ci sia almeno il valore di telefono o cellulare.
 */
function SetValueProvincia() {
    var key = $('#gridIndirizziSpedizione').dxDataGrid('instance').option('editing.editRowKey');
    var index = $('#gridIndirizziSpedizione').dxDataGrid('instance').getRowIndexByKey(key);
    var prov = $('#SelectProvincia').dxSelectBox('instance').option('value');

    var cellValue = $('#gridIndirizziSpedizione [name="Cellulare"]').val();
    var telValue = $('#gridIndirizziSpedizione [name="Telefono"]').val();
    //$('#SelectProvincia').dxSelectBox('instance').option('disabled', true);
    $('#gridIndirizziSpedizione').dxDataGrid('instance').cellValue(index, 'Provincia', prov);

    var check = $('#hErrRecapito');
    var valid = true;

    if (!cellValue && !telValue) {
        check.removeClass('hidden');
        valid = false;
    }
    else {
        check.addClass('hidden');
        if (cellValue.length > 0) {
            $('#gridIndirizziSpedizione [name="Cellulare"]').val(cellValue);
        }
        if (telValue.length > 0) {
            $('#gridIndirizziSpedizione [name="Telefono"]').val(telValue);
        }
    }

    if (valid === true) {
        $('#gridIndirizziSpedizione').dxDataGrid('instance').saveEditData();
    }
}